import { createLucideIcon } from "lucide-react"
export const Grid = createLucideIcon("grid", [
  [
    "path",
    {
      d: "M 14.5 2.5 L 14.5 21.5",
      key: "363hpm",
    },
  ],
  [
    "path",
    {
      d: "M 19.5 2.5 L 19.5 21.5",
      key: "17bnft",
    },
  ],
  [
    "path",
    {
      d: "M 2.5 14.5 L 21.5 14.5",
      key: "5ja9oq",
    },
  ],
  [
    "path",
    {
      d: "M 2.5 19.5 L 21.5 19.5",
      key: "3rc24q",
    },
  ],
  [
    "path",
    {
      d: "M 2.5 4.5 L 21.5 4.5",
      key: "12f5r6",
    },
  ],
  [
    "path",
    {
      d: "M 2.5 9.5 L 21.5 9.5",
      key: "1n1v5o",
    },
  ],
  [
    "path",
    {
      d: "M 4.5 2.5 L 4.5 21.5",
      key: "1spspf",
    },
  ],
  [
    "path",
    {
      d: "M 9.5 2.5 L 9.5 21.5",
      key: "1dn93n",
    },
  ],
])
